import React, { Fragment, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "@context/AuthContext";
import routes from "@routes/routes";

const ProtectedRoute: React.FC = () => {
  const auth = useContext(AuthContext);

  return (
    <Fragment>{auth ? <Outlet /> : <Navigate to={routes.default} />}</Fragment>
  );
};

export default ProtectedRoute;
